/* 100X Equine slide-out cart, wired to the real Shopify Cart AJAX API.
   Opens on the buy box's gx:add-to-cart event and on any [data-open-cart].
   Adds the selected variant + selling plan, renders lines, changes qty,
   removes, updates the nav count, and sends to /checkout. */
(function () {
  // gutx-cart is the real Shopify cart and the single drawer we keep. On shop/home the React
  // bundle cart (#gx-bundle-root) also mounted, which made two drawers open together. Remove
  // that React mount so only this cart shows. Landing pages/PDPs never had it, so they are
  // unaffected; this drawer serves every page.
  // data-calc-only = Quick Calculator-only mount (2026-08-13): renders no cart drawer, so it
  // is not the double-drawer this removal exists for. Remove only full cart mounts.
  var reactCartRoot = document.getElementById('gx-bundle-root');
  if (reactCartRoot && !reactCartRoot.hasAttribute('data-calc-only')) reactCartRoot.remove();

  // OCU division of labour. OCU does NOT perform the add for a custom button - verified against
  // its own handleAddToCart, which adds nothing. What it does is watch /cart/add.js (it patches
  // window.fetch) and, once it recognises the click as an add (see assets/gx-ocu-bridge.js),
  // open its slide cart. So this file stays the ADD ENGINE and simply never shows its own
  // drawer while OCU is installed. Checked lazily, because OCU injects .ocu-cart-drawer into
  // the DOM after this script has already run.
  function ocuActive() { return !!document.querySelector('.ocu-cart-drawer'); }

  window.__gxCartModule = true; // tells the buy box to hand off here, not direct-add

  var drawer = document.querySelector('[data-gx-drawer]');
  var scrim = document.querySelector('[data-gx-drawer-scrim]');
  if (!drawer || !scrim) return;
  var linesEl = drawer.querySelector('[data-gx-drawer-lines]');
  var emptyEl = drawer.querySelector('[data-gx-drawer-empty]');
  var totalEl = drawer.querySelector('[data-gx-drawer-total]');
  var countEl = drawer.querySelector('[data-gx-drawer-count]');

  function money(cents) { return '$' + (Number(cents) / 100).toFixed(2); }

  // Body scroll-lock: save the previous overflow and RESTORE it on close (doc 2), not a blind
  // clear to '', so Dawn's own overflow (if one of its drawers set it) is never clobbered.
  var prevBodyOverflow = '';
  function open() {
    if (ocuActive()) return;   // OCU shows its own slide cart; never two carts at once
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    scrim.setAttribute('data-open', 'true');
    prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.setAttribute('data-open', 'false');
    document.body.style.overflow = prevBodyOverflow;
  }

  function setNavCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }

  function render(cart) {
    var items = cart.items || [];
    setNavCount(cart.item_count || 0);
    if (countEl) countEl.textContent = cart.item_count ? cart.item_count : '';
    if (!items.length) {
      linesEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = '';
      if (totalEl) totalEl.textContent = money(0);
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    linesEl.innerHTML = items.map(function (it) {
      var plan = it.selling_plan_allocation ? '<small>' + (it.selling_plan_allocation.selling_plan.name || 'Subscription') + '</small>' : '<small>One-time</small>';
      return '<li class="gx-dr-line" data-key="' + it.key + '">' +
        '<div class="gx-dr-qty">' +
          '<button data-gx-dec aria-label="Decrease">&ndash;</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button data-gx-inc aria-label="Increase">+</button>' +
        '</div>' +
        '<div class="gx-dr-nm"><b>' + it.product_title + '</b>' + plan + '</div>' +
        '<span class="gx-dr-lp">' + money(it.final_line_price) + '</span>' +
        '<button class="gx-dr-rm" data-gx-rm aria-label="Remove">&times;</button>' +
      '</li>';
    }).join('');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  // ----- add from the buy box -----
  window.addEventListener('gx:add-to-cart', function (e) {
    var d = e.detail || {};
    if (!d.variantId) return;
    var line = { id: Number(d.variantId), quantity: 1 };
    if (d.sellingPlanId) line.selling_plan = Number(d.sellingPlanId);
    var items = [line];
    // GWP hook: new-subscription 2-gal -> free 1/2 gal, 4-gal -> free 1 gal.
    // Activates when the $0 gift SKUs exist (launch window); no-op until then.
    if (d.sellingPlanId && window.GX_GIFT && window.GX_GIFT[String(d.tier || '')]) {
      items.push({ id: Number(window.GX_GIFT[String(d.tier)]), quantity: 1 });
    }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () {
        // OCU installed: it renders the cart UI, but it only opens itself off its OWN click
        // path (the header cart button). It never opens on our add, because its internal
        // add pipeline does nothing for a custom button. So tell it explicitly: refresh and
        // slide open. 'ocu:cart:open:updated' is OCU's own public event - not a toggle, so
        // it cannot accidentally close an already-open cart.
        if (ocuActive()) {
          window.dispatchEvent(new CustomEvent('ocu:cart:open:updated'));
          return;
        }
        open();
      })
      .catch(function () {});
  });

  // ----- drawer controls -----
  scrim.addEventListener('click', close);
  drawer.querySelector('[data-gx-drawer-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  var checkoutBtn = drawer.querySelector('[data-gx-drawer-checkout]');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () { window.location.href = '/checkout'; });

  // open on any [data-open-cart] (nav cart)
  document.querySelectorAll('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); refresh().then(open); });
  });

  // qty +/- and remove (delegated)
  linesEl.addEventListener('click', function (e) {
    var li = e.target.closest('.gx-dr-line');
    if (!li) return;
    var key = li.getAttribute('data-key');
    var qty = Number(li.querySelector('.gx-dr-qty span').textContent) || 1;
    if (e.target.closest('[data-gx-inc]')) change(key, qty + 1);
    else if (e.target.closest('[data-gx-dec]')) change(key, Math.max(0, qty - 1));
    else if (e.target.closest('[data-gx-rm]')) change(key, 0);
  });

  refresh();
})();
